import React, {Component} from 'react';
import SVG from 'react-inlinesvg';
import {classNamesPrefixed} from '../../../core/helpers/CoreHelpers';
import FeedBackIcon from '../../assets/images/feedback-icon.svg';
import FocusAreaIcon from '../../assets/images/focus-area-icon.svg';
import PrivateNotesIcon from '../../assets/images/private-notes-icon.svg';
import CloseIcon from '../../assets/images/close-icon.svg';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faChevronDown, faChevronUp} from '@fortawesome/pro-solid-svg-icons';
import axios from "axios";
import Config from "../../config";
import FlyOutFeedbackItem from "../UI/FlyOutFeedbackItem";
import moment from "moment";
import SimpleBar from 'simplebar-react';
import {I18n} from 'react-i18nify';
import ReactDOM from 'react-dom';
import AwaveConfirm from "../UI/AwaveConfirm";
import { connect } from "react-redux";

/**
 * Content item
 * @param badge
 * @param children
 * @returns {*}
 * @constructor
 */
const ContentItem = ({badge, children, isFeedback}) => {

    return (
        <div className={classNamesPrefixed({
            'flyout-block-item-content-item': true,
            'flyout-block-item-content-item--with-badge': badge,
            'feedback-content-item': isFeedback
        }, false)}>
            {badge &&
            <div className='flyout-block-item-content-item-badge'>{badge}</div>
            }
            {children}
        </div>
    )
};

/**
 * Tab item
 * @param currentTab
 * @param tab
 * @param selectTab
 * @returns {*}
 * @constructor
 */
const TabItem = ({currentTab, tab, selectTab}) => {
    return (
        <div
            onClick={() => selectTab(tab)}
            className={classNamesPrefixed({
                'flyout-block-tabs-item': true,
                'flyout-block-tabs-item--active': currentTab && currentTab.name === tab.name
            }, false)}
        >
            <div className={'flyout-block-tabs-item-icon'}>
                {tab.icon}
            </div>
            <div className={'flyout-block-tabs-item-name'}>
                {tab.name}
            </div>
        </div>
    );
};

/**
 * ExpandableText
 */
class ExpandableText extends Component {
    state = {
        expanded: false
    };

    expand = () => {
        this.setState({
            expanded: true
        });
    };

    collapse = () => {
        this.setState({
            expanded: false
        });
    };

    render() {
        const {expanded} = this.state;
        const {expandText, collapseText, text} = this.props;

        return (
            <div className={'flyout-block-item-content-item-expandable-text'}>
                {!expanded ? (
                    <div className={'flyout-block-item-content-item-expandable-text-expand'} onClick={this.expand}>
                        {expandText}
                        <FontAwesomeIcon icon={faChevronDown}/>
                    </div>
                ) : (
                    <React.Fragment>
                        <div className={'flyout-block-item-content-item-expandable-text-expand'} onClick={this.collapse}>
                            {collapseText}
                            <FontAwesomeIcon icon={faChevronUp}/>
                        </div>
                        <div className={'flyout-block-item-content-item-expandable-text-text'}>
                            {I18n.t('flyOutBlock.description')}
                            <div dangerouslySetInnerHTML={{__html: text}}/>
                        </div>
                    </React.Fragment>
                )}
            </div>
        );
    }
}

/**
 * FeedBackContent
 */
class FeedBackContent extends Component {
    state = {
        false: true,
        items: []
    };

    componentDidMount() {
        this.setState({
            items: this.props.data
        });
    }

    render() {
        const {items} = this.state;
        const { csodUserId } = this.props;

        return (
            <div className={'flyout-block-item-content'}>
                <SimpleBar
                    className={items.length > 0 ? 'simplebar-boxshadow' : ''}
                    style={{maxHeight: 'calc(100vh - 300px)'}}
                    autoHide={false}
                >
                {items.length > 0 ? (
                    <React.Fragment>
                        {items.map((item, index) => {
                            let initials = item.providerName.split(', ');

                            let initialsFromProviderName = '';

                            if (initials[0]) {
                                initialsFromProviderName += initials[0].charAt(0);
                            }

                            if (initials[1]) {
                                initialsFromProviderName += initials[1].charAt(0);
                            }

                            return(<FlyOutFeedbackItem item={item} key={index} initialsFromProviderName={initialsFromProviderName} />);
                        })}
                    </React.Fragment>
                ) : (
                            <div>Looks like there is no feedback for you yet. Go to <a href={'/phnx/driver.aspx?routename=Social/UniversalProfile/Feedback&TargetUser=' + csodUserId}>"My feedback"</a> page to request feedback from your colleagues</div>
                )}
                </SimpleBar>
            </div>
        );
    }
}

/**
 * FocusAreasContent
 */
class FocusAreasContent extends Component {
    state = {
        items: []
    };

    componentDidMount() {
        this.setState({
            items: this.props.data
        });
    }

    render() {
        const {items} = this.state;

        return (
            <div className={'flyout-block-item-content'}>
                <SimpleBar
                    className={items.length > 0 ? 'simplebar-boxshadow' : ''}
                    style={{maxHeight: 'calc(100vh - 300px)'}}
                    autoHide={false}
                >
                {items.length > 0 ? (
                    <React.Fragment>
                        {items.map((item, index) => {
                            return (
                                <ContentItem key={index}>
                                    <div className={'flyout-block-focus-areas-content-title'}>
                                        {item.title}
                                    </div>
                                    <div className={'flyout-block-focus-areas-content-dates'}>
                                        <div>{I18n.t('flyOutBlock.startDate')} {moment.unix(item.startDate).utc(false).format("DD-MM-YYYY")}</div>
                                        <div>{I18n.t('flyOutBlock.dueDate')} {moment.unix(item.targetDate).utc(false).format("DD-MM-YYYY")}</div>
                                    </div>
                                    <div
                                        className={'flyout-block-focus-areas-content-statuses'}
                                    >
                                        <div>{I18n.t('flyOutBlock.progress')} {item.status}</div>
                                        <div className={'flyout-block-focus-areas-content-tag'}>
                                            {item.categories.split(",").join(", ")}
                                        </div>
                                    </div>
                                    <ExpandableText
                                        expandText={I18n.t('flyOutBlock.expandText')}
                                        collapseText={I18n.t('flyOutBlock.collapseText')}
                                        text={item.description}
                                    />
                                </ContentItem>
                            );
                        })}
                    </React.Fragment>
                    ) : (
                    <div>{I18n.t('flyOutBlock.noData')}</div>
                )}
                </SimpleBar>
            </div>
        );
    }
}

/**
 * PrivateNotesContent
 */
class PrivateNotesContent extends Component {
    state = {
        dirty: false,
        note: ''
    };

    componentDidMount() {
        // this.setState({
        //     note: this.props.data ? this.props.data : ''
        // });
        if (this.textAreaRef) {
            this.textAreaRef.style.height = this.textAreaRef.scrollHeight + "px";
        }

        axios.get(Config.api.endpoint + 'api/User/notes', Config.getApiConfig()).then(response => {
            this.setState({
                note: response.data ? response.data : ''
            })
        });
    }

    setNote = (event) => {
        const {updatePersonalNoteHasChanged} = this.props;
        const note = event.target.value;

        event.target.style.height = (event.target.scrollHeight) + "px";

        this.setState({
            dirty: true,
            note: note
        }, () => updatePersonalNoteHasChanged(true));
    };

    save = () => {
        const {updatePersonalNoteHasChanged} = this.props;
        const {note, dirty} = this.state;

        if (dirty) {
            axios.post(Config.api.endpoint + 'api/User/notes', JSON.stringify(note), Config.getApiConfig({headers: {'Content-Type': 'application/json-patch+json'}})).then(() => {
                this.setState({
                    dirty: false
                }, () => updatePersonalNoteHasChanged(false));
            });
        }
    };

    render() {
        const {dirty, note} = this.state;

        return (
            <div
                className={classNamesPrefixed({
                    'flyout-block-item-content': true,
                    'flyout-block-item-content--inner': true
                }, false)}
            >
            <React.Fragment>
                <div className={'flyout-block-item-content-note'}>
                    <SimpleBar
                        style={{maxHeight: 'calc(100vh - 300px)'}}
                    >
                    <textarea 
                        value={note} 
                        onChange={this.setNote}
                        ref={textAreaRef=> this.textAreaRef = textAreaRef}
                    />
                    </SimpleBar>
                </div>
                <div className={'flyout-block-item-content-footer'}>
                    <div
                        className={classNamesPrefixed({
                            'flyout-block-item-content-save': true,
                            'flyout-block-item-content-save--disabled': !dirty
                        }, false)}
                        onClick={this.save}
                    >
                        {I18n.t('flyOutBlock.saveChanges')}
                    </div>
                </div>
            </React.Fragment>
            </div>
        );
    }
}

/**
 * FlyOutBlock
 */
class FlyOutBlock extends Component {
    state = {
        currentTab: null,
        tabs: [],
        personalNoteHasChanged: false,
        showConfirm: false
    };

    componentDidMount() {
        const {relatedContents} = this.props;

        let note = "";
        let feedbacks = [];
        let goals = [];

        if (relatedContents && relatedContents[0]) {
            note = relatedContents[0].note;
            feedbacks = relatedContents[0].feedbacks;
            goals = relatedContents[0].goals;
        }

        this.setState({
            tabs: [
                {
                    icon: <SVG src={FeedBackIcon}/>,
                    name: "Feedback",
                    title: "Feedback",
                    content: <FeedBackContent 
                            csodUserId={this.props.user.user_csod_id}
                            data={feedbacks}
                        />
                },
                {
                    icon: <SVG src={FocusAreaIcon}/>,
                    name: "Focus Areas",
                    title: "Focus Areas",
                    content: <FocusAreasContent data={goals}/>
                },
                {
                    icon: <SVG src={PrivateNotesIcon}/>,
                    name: "Personal Notes",
                    title: "Personal Notes",
                    content: <PrivateNotesContent 
                                updatePersonalNoteHasChanged={this.updatePersonalNoteHasChanged}
                                data={note}
                            />
                }
            ]
        });
    }

    updatePersonalNoteHasChanged = (value) => {
        this.setState({
            personalNoteHasChanged: value
        });
    };

    confirmCancel = (e) => {
        e.preventDefault();

        this.setState({
            showConfirm: false
        });
    };

    confirmOk = (e) => {
        const {showConfirm} = this.state;

        e.preventDefault();

        this.setState({
            showConfirm: false,
            currentTab: showConfirm.tab,
            personalNoteHasChanged: false
        });
    };

    openConfirm = (tab = null) => {
        this.setState({
            showConfirm: {
                tab: tab,
                notice: I18n.t('notesPopup.notice'),
                labelCancel: I18n.t('notesPopup.labelCancel'),
                labelOk: I18n.t('notesPopup.labelConfirm')
            }
        });
    };

    close = () => {
        const {personalNoteHasChanged} = this.state;

        if (personalNoteHasChanged) {
            this.openConfirm();
        } else {
            this.setState({
                currentTab: null
            });
        }
    };

    selectTab = (tab) => {
        const {personalNoteHasChanged} = this.state;

        if (personalNoteHasChanged) {
            this.openConfirm(tab);
        } else {
            this.setState({
                currentTab: tab,
                personalNoteHasChanged: false
            });
        }
    };

    render() {
        const {currentTab, tabs, showConfirm} = this.state;

        return (
            <React.Fragment>
                {currentTab &&
                <div className={'flyout-block-dimmer'} onClick={this.close}/>
                }
                {showConfirm &&
                ReactDOM.createPortal(
                    <AwaveConfirm
                        type="default"
                        data={showConfirm}
                        confirmCancel={this.confirmCancel}
                        confirmOk={this.confirmOk}
                  />, document.getElementById("application")
                )
                }
                <div className={'flyout-block'}>
                    <div
                        className={classNamesPrefixed({
                            'flyout-block-tabs': true,
                            'flyout-block-tabs--with-content': currentTab,
                            'flyout-block-tabs--without-content': !currentTab
                        }, false)}
                    >
                        {tabs.map(tab => {
                            return (
                                <TabItem
                                    key={tab.name}
                                    currentTab={currentTab}
                                    tab={tab}
                                    selectTab={this.selectTab}
                                />
                            );
                        })}
                    </div>
                    {currentTab &&
                    <div className={'flyout-block-content'}>
                        <div className={'flyout-block-content-title'}>
                            {currentTab.title}
                        </div>
                        <div onClick={this.close} className={'flyout-block-content-close'}>
                            <SVG src={CloseIcon}/>
                        </div>
                        <div className={'flyout-block-content-main'}>
                            {currentTab.content}
                        </div>
                    </div>
                    }
                </div>
            </React.Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        user: state.user
    };
};

export default connect(mapStateToProps)(FlyOutBlock);
export {ContentItem};


// WEBPACK FOOTER //
// ./src/frontend/components/Blocks/FlyOutBlock.js